import { ESSENTIAL_ITEMS_NAMES, ESSENTIAL_ITEMS_REGEX } from '../constants'

export function getOptionalTrackers(source: Record<string, string>): string[] {
  return Object.keys(source).filter((trackerName) => {
    return (
      !ESSENTIAL_ITEMS_NAMES.includes(trackerName) &&
      !ESSENTIAL_ITEMS_REGEX.test(trackerName)
    )
  })
}
